import actionTypes from '../constants/action-types';
import { DISPLAY_MODES } from '../constants/common';

const displayMode = (state = DISPLAY_MODES.FLOATING, action) => {
  if (action.type !== actionTypes.SET_DISPLAY_MODE) return state;

  return action.payload.value;
};

export default displayMode;
